import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Button,
  Space,
  Select,
  message,
} from "antd";
import { useTranslation } from "react-i18next";
import { CreateMealDto, mealTypes } from "../../../../types/meal.types";
import { useMealActions } from "../../../../hooks/useMeals";
import { handleApiError } from "../../../../utils/errorHandler";
import dayjs from "dayjs";

const { TextArea } = Input;

interface CreateMealModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  branchId?: number;
}

const CreateMealModal: React.FC<CreateMealModalProps> = ({
  visible,
  onCancel,
  onSuccess,
  branchId,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { createMeal, assignMealToDate, loading } = useMealActions();

  const handleSubmit = async (values: any) => {
    try {
      if (!branchId) {
        message.error('Lütfen önce şube seçin!');
        return;
      }

      const selectedBranchId = branchId;
      
      const mealData: CreateMealDto = {
        title: values.title,
        description: values.description,
        type: values.type,
        branch: { id: selectedBranchId },
      };


      const result = await createMeal(mealData);

      if (result) {
        // Eğer tarih seçilmişse, yemeği o tarihe ata
        if (values.date) {
          const dateStr = dayjs(values.date).format("YYYY-MM-DD");

          try {
            await assignMealToDate(result.id, {
              date: dateStr,
              branchId: selectedBranchId,
            });
          } catch (assignError) {
            handleApiError(assignError);
            message.warning("Yemek oluşturuldu ancak tarihe atanamadı");
          }
        }

        form.resetFields();
        onSuccess();
      }
    } catch (error: any) {
      handleApiError(error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Yeni Yemek Ekle"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          date: dayjs(),
        }}
      >
        <Form.Item
          name="title"
          label="Yemek Adı"
          rules={[
            { required: true, message: "Yemek adı gereklidir!" },
            { min: 2, message: "Yemek adı en az 2 karakter olmalıdır!" },
          ]}
        >
          <Input placeholder="Örn: Köfte Pilav" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Açıklama"
          rules={[
            { max: 500, message: "Açıklama en fazla 500 karakter olabilir!" },
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Yemek hakkında detaylı bilgi giriniz..."
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item
          name="type"
          label="Yemek Türü"
          rules={[{ required: true, message: "Yemek türü seçimi gereklidir!" }]}
        >
          <Select options={mealTypes} placeholder="Yemek türü seçiniz" />
        </Form.Item>

        {/* <Form.Item name="date" label="Tarih (Opsiyonel)">
          <DatePicker
            style={{ width: "100%" }}
            format="DD.MM.YYYY"
            placeholder="Tarih seçiniz (opsiyonel)"
            disabledDate={(current) => {
              // Geçmiş tarihleri engelle
              return current && current < dayjs().startOf("day");
            }}
          />
        </Form.Item> */}

        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
          <Space style={{ width: "100%", justifyContent: "flex-end" }}>
            <Button onClick={handleCancel}>İptal</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Yemek Ekle
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateMealModal;
